import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Alert } from 'reactstrap';

import ApiService from '@app/Services/ApiService';
import { SignalREvents } from '@app/AppConstants/SignalR';
import { ApiUrls } from '@app/AppConstants/ApiUrls';
import { EasaAlertModel } from '@app/Models/WebApiModels';
import { Icon } from '@app/Components/Icon';
import { signalRService } from '@app/Services/SignalRService';
import Extensions from '@app/Services/Extensions';
import { applyDecorators, EmptyProps } from "@app/Helpers/Decorator";
import { navigationStore } from '@app/Stores/NavigationStore';

@observer
export default class EasaAlertBar extends React.Component {
    @observable maintenance: EasaAlertModel = { hasErrors: false };
    private _timer: number | null = null;
    private _delay: number = 15 * 60 * 1000;
    @observable isOpen: boolean = true;

    constructor(props: EmptyProps) {
        super(props);
        applyDecorators(this);
    }

    componentDidMount(): void {
        Extensions.executeTimeout(this.getData, 5000, this);
        signalRService.subscribeToGroup(SignalREvents.updateEasaAlert, this.updateData);
    }

    componentWillUnmount(): void {
        signalRService.unsubscribeFromGroup(SignalREvents.updateEasaAlert, this.updateData);
    }

    render() {
        const isVisible = this.maintenance.hasErrors;
        if (!isVisible) return null;

        return (
            <React.Fragment>
                <Alert color={'danger'} isOpen={this.isOpen} fade={false} className="maintenance-bar">
                    <div className="maintenance-body">
                        <div className="maintenance-title">
                            EASA Alert {" "}
                            <img onClick={this.onClickNavigateToErrors} alt="Navigate to errors" title="Navigate to errors" src={'/images/target.svg'} style={{ 'width': '14px', 'height': '14px', 'cursor': 'pointer', 'marginTop': '-2px' }} />
                        </div>
                        {this.maintenance.messages && this.maintenance.messages.map((x, index) => <div key={'easaAlert_' + index} className="maintenance-caption"> * {x}</div>)}
                    </div>
                    <a className="close" onClick={this.onClose}>
                        <Icon name="times" />
                    </a>
                </Alert>
            </React.Fragment>
        );
    }

    @action.bound
    async getData() {
        const { data } = await ApiService.getTypedData<EasaAlertModel>(ApiUrls.ErrorReportUrl);
        this.maintenance = data;
    }

    @action
    updateData = (category: string, messages?: string[]) => {
        const isMessageChanged = JSON.stringify(this.maintenance.messages || []) !== JSON.stringify(messages || []);

        if (isMessageChanged) {
            this.maintenance.hasErrors = (messages && messages.length > 0) === true;
            this.maintenance.messages = messages;
            if (!this.isOpen && this.maintenance.hasErrors) {
                this.isOpen = true;
            } else if (this.isOpen && !this.maintenance.hasErrors) {
                this.isOpen = false;
            }
        }
    };

    onClose = () => {
        this.isOpen = false;
        this.setupInterval();
    };

    setupInterval() {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
        this._timer = window.setTimeout(() => {
            this.isOpen = true;
        }, this._delay);
    }

    onClickNavigateToErrors = () => {
        const easa2hErrorsId = '10';
        navigationStore.redirect(`/?resetFilters=true&releaseFilterTypes=${easa2hErrorsId}`);
    };
}